import React, { useEffect, useRef, useState } from 'react';

import CollapsibleWrapper from '~/components/core/Collapsible/CollapsibleWrapper';
import Text from '~/components/core/TextComponents/Text';

import AgentTimeline from './AgentTimeline';
import type { AgentThinkingSectionProps } from './types';

const AgentThinkingSection: React.FC<AgentThinkingSectionProps> = ({
  title = 'Thinking...',
  timelineEntries,
  isExpanded: controlledExpanded,
  onToggle: controlledOnToggle,
  defaultExpanded = false,
  isDefaultTimelineExpanded = true,
}) => {
  const [internalExpanded, setInternalExpanded] = useState(defaultExpanded);
  const wasGeneratingRef = useRef(defaultExpanded);

  useEffect(() => {
    if (wasGeneratingRef.current && !defaultExpanded) {
      setInternalExpanded(false);
    }
    wasGeneratingRef.current = defaultExpanded;
  }, [defaultExpanded]);

  const isControlled = controlledExpanded !== undefined;
  const isExpanded = isControlled ? controlledExpanded : internalExpanded;

  const handleToggle = () => {
    if (isControlled && controlledOnToggle) {
      controlledOnToggle();
    } else {
      setInternalExpanded(!internalExpanded);
    }
  };

  if (timelineEntries.length === 0) {
    return null;
  }

  const customTitle = (
    <Text variant={Text.VARIANTS.SM} weight={Text.WEIGHTS.MEDIUM} className="text-blue-600">
      {title}
    </Text>
  );

  return (
    <div className="agent-thinking-section">
      <CollapsibleWrapper
        className="mb-0"
        title={customTitle}
        open={isExpanded}
        onCollapse={handleToggle}
        timeout={300}
        unmountOnExit
        noBorder
        noBackground
        chevronContainerClassName="hidden"
      >
        <div className="mt-12">
          <AgentTimeline entries={timelineEntries} isDefaultExpanded={isDefaultTimelineExpanded} />
        </div>
      </CollapsibleWrapper>
    </div>
  );
};

export default AgentThinkingSection;
